module.exports = __webpack_public_path__ + "img/business-men.b1573c69.jpg";